import React from 'react';
import {classes, style} from './doppe-viewer-map-details.st.css';
import {
    Button,
    cssGap,
    flexColumn,
    flexJustifyContentSpaceBetween,
    flexRowAlignToCenter
} from "@wix/devzai-utils-react";
import {DoppeViewerAppIconNavigate} from "../../doppe-viewer-icons/doppe-viewer-icons";
import type {LocationCoordinates} from "@wix/devzai-utils-common";
import {buildLocationNavigateToUrl} from "@wix/devzai-utils-common";

export const DoppeViewerMapDetails = React.memo(function DoppeViewerMapDetails (props: DoppeViewerMapDetails.Props) {
    const {
        className,
        addressTitle,
        displayAddress,
        locationCoordinates,
        ...htmlAttributes
    } = props;

    const {latitude, longitude} = locationCoordinates;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, flexRowAlignToCenter(), flexJustifyContentSpaceBetween(), className)}
        >
            <div className={style(classes.detailsTextContainer, flexColumn(), cssGap(8))}>
                <div className={classes.title}>{addressTitle}</div>
                <div className={classes.details}>{displayAddress}</div>
            </div>
            <Button
                className={classes.navigateButton}
                tagName={'a'}
                href={buildLocationNavigateToUrl(latitude, longitude)}
                rel={'noreferrer'}
                target={'_blank'}
            >
                <DoppeViewerAppIconNavigate />
            </Button>
        </div>
    );
});

export namespace DoppeViewerMapDetails {
    export interface Props extends React.HTMLAttributes<any> {
        addressTitle: string;
        displayAddress: string;
        locationCoordinates: LocationCoordinates;
    }
}
